import classNames from 'classnames';
import { useMemo } from 'react';
import Icon from '../../icons';
import { InformativeModalProps } from '../../interfaces';
import CustomButton from '../Button';
import { HorizontalInformativeModal, VerticalInformativeModal } from './styles';
import './styles.scss';

const InformativeModal: React.FC<InformativeModalProps> = props => {
  const {
    children,
    onCancel,
    className,
    error = false,
    footer: _footer,
    title = 'Modal',
    layout = 'horizontal',
    destroyOnClose = true,
    icon = <Icon name="bell" width={24} height={30} />,
    ...rest
  } = props;

  const Wrapper =
    layout === 'horizontal'
      ? HorizontalInformativeModal
      : VerticalInformativeModal;

  const footer = useMemo(() => {
    return (
      _footer ?? [
        <CustomButton
          size="large"
          key="ok-btn"
          width={'100%'}
          onClick={e => {
            onCancel?.(e as any);
          }}
        >
          OK
        </CustomButton>,
      ]
    );
  }, [_footer, onCancel]);

  return (
    <Wrapper
      {...rest}
      onCancel={onCancel}
      title={
        <>
          {icon && <div className="iconWrapper">{icon}</div>}
          {title}
        </>
      }
      footer={footer}
      wrapClassName="custom-modal-wrap"
      closeIcon={<Icon name="close" />}
      destroyOnClose={destroyOnClose}
      className={classNames(className, { error })}
    >
      {children}
    </Wrapper>
  );
};

export default InformativeModal;
